import { ExpandOutlined, FileTextOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import CustomChatItem from '../ChatItem';
import { ContentObject } from '../../../interfaces/copilotChat';
import { getArtifactContent } from '../../../utils/artifactUtils';

interface ArtifactMessageProps {
  className?: string;
  result: ContentObject;
  onClick: (artifact: ContentObject) => void;
}

const ArtifactMessage: React.FC<ArtifactMessageProps> = ({
  className,
  result,
  onClick,
}) => {
  return (
    <div className={className}>
      <div className="artifact-message-view">
        <Button onClick={() => onClick(result)}>
          <FileTextOutlined />
          <span>{result.title ?? 'View Artifact'}</span>
        </Button>
      </div>
      <div className="artifact-message-chat-item">
        <div
          className="custom-chat-item-wrapper"
          onClick={() => onClick(result)}
        >
          <div className="chat-item-header">
            <div className="header-left">
              <FileTextOutlined className="file-icon" />
              <span className="header-title">{result.title ?? 'Artifact'}</span>
            </div>
            <div className="header-right">
              <ExpandOutlined className="expand-icon" />
            </div>
          </div>
          <div className="chat-item-body">
            <CustomChatItem message={getArtifactContent(result)} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArtifactMessage;
